// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const checkbox = "Checkbox__checkbox__wweuP";
export const input = "Checkbox__input__x0nIS";
export const label = "Checkbox__label__x07ar font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const mark = "Checkbox__mark__+r1s7";